<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="京东安装差评率" name="first">
        <JdInstallEvaluate></JdInstallEvaluate>
      </el-tab-pane>
      <el-tab-pane label="京东满意度" name="second">
        <JdSatisfaction></JdSatisfaction>
      </el-tab-pane>
      <el-tab-pane label="京东授权店铺" name="thrid">
        <JdBuyShopInclude></JdBuyShopInclude>
      </el-tab-pane>
      <el-tab-pane label="服务商赛区" name="forth">
        <ServiceProviderRegion></ServiceProviderRegion>
      </el-tab-pane>
      <el-tab-pane label="京东物流" name="fifth">
        <JdDeliveryInfo></JdDeliveryInfo>
      </el-tab-pane>
      <el-tab-pane label="天猫物流" name="sixth">
        <TmDeliveryInfo></TmDeliveryInfo>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import JdInstallEvaluate from "@/views/workorder/ebusiness/ebusinessImport/components/jdInstallEvaluate.vue";
import JdSatisfaction from "@/views/workorder/ebusiness/ebusinessImport/components/jdSatisfaction.vue";
import JdBuyShopInclude from "@/views/workorder/ebusiness/ebusinessImport/components/jdBuyShopInclude.vue";
import ServiceProviderRegion from "@/views/workorder/ebusiness/ebusinessImport/components/ServiceProviderRegion.vue";
import JdDeliveryInfo from "@/views/workorder/ebusiness/ebusinessImport/components/jdDeliveryInfo.vue";
import tmDeliveryInfo from "@/views/workorder/ebusiness/ebusinessImport/components/tmDeliveryInfo.vue";
import TmDeliveryInfo from "@/views/workorder/ebusiness/ebusinessImport/components/tmDeliveryInfo.vue";

export default {
  components: {
    JdInstallEvaluate,
    JdSatisfaction,
    JdBuyShopInclude,
    ServiceProviderRegion,
    JdDeliveryInfo,
    TmDeliveryInfo
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}

// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}

.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;
}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #fff;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #ebeef5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;
}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}

::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}

::v-deep .el-cascader--medium {
  height: 38px;
}
</style>
